import { useAuthentication } from '@givebacks/api';
import { useForm } from '@givebacks/formy';
import { CheckboxCard } from 'ui';

type KeepMeUpdatedForm = {
  keep_me_updated: boolean;
};

const CheckoutKeepMeUpdated = ({ causeName }: { causeName?: string }) => {
  const { isAuthenticated } = useAuthentication();

  const form = useForm<KeepMeUpdatedForm>(
    {
      initialValues: {
        keep_me_updated: true,
      },
      validate: {},
    },
    {
      id: 'keep_me_updated',
    }
  );

  if (isAuthenticated) return null;
  return (
    <CheckboxCard
      description={`I want Givebacks to keep me updated on new ways to support ${
        causeName ?? 'my cause'
      }`}
      bg="white"
      {...form.getInputProps('keep_me_updated', { type: 'checkbox' })}
    />
  );
};

export { CheckoutKeepMeUpdated };
export type { KeepMeUpdatedForm };
